import { render, staticRenderFns } from "./OlabSampleSVGGen.vue?vue&type=template&id=688d4dea&"
import script from "./OlabSampleSVGGen.vue?vue&type=script&lang=js&"
export * from "./OlabSampleSVGGen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports